import styled from 'styled-components';

export const StyledChromePickerPosition = styled.div`
  position: relative;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
`;
